import React from 'react';
import { Zap, Shield, Headphones, Database, Settings, Activity } from 'lucide-react';
import { features } from '../mock';

const iconMap = {
  Zap,
  Shield,
  Headphones,
  Database,
  Settings,
  Activity
};

const FeaturesSection = () => {
  return (
    <section id="features" className="py-24 bg-gradient-to-b from-white to-slate-50 dark:from-[hsl(222.2_47.4%_11.2%)] dark:to-[hsl(222.2_47.4%_11.2%)] relative">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 dark:text-foreground mb-4">
            لماذا تختار <span className="text-[#4A9FD8]">إستضافتنا</span>؟
          </h2>
          <p className="text-xl text-gray-600 dark:text-muted-foreground max-w-2xl mx-auto">
            نقدم لك أفضل الخدمات والمميزات التي تجعل موقعك في المقدمة
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group bg-white dark:bg-card rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-[#4A9FD8]/30 hover:-translate-y-2"
                style={{
                  animationDelay: `${index * 100}ms`
                }}>

                {/* Icon Container */}
                <div className="w-16 h-16 bg-gradient-to-br from-[#4A9FD8]/10 to-[#4A9FD8]/20 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="text-[#4A9FD8]" size={32} />
                </div>

                {/* Title */}
                <h3 className="text-2xl font-bold text-gray-800 dark:text-foreground mb-3">
                  {feature.title}
                </h3>

                {/* Description */}
                <p className="text-gray-600 dark:text-muted-foreground leading-relaxed">
                  {feature.description}
                </p>
              </div>);

          })}
        </div>
      </div>
    </section>);

};

export default FeaturesSection;